export const orderStatuses = [
  "WAITING_FOR_ADDRESS",
  "WAITING_FOR_PURCHASE",
  "WAITING_FOR_SHIPMENT_TO_WAREHOUSE",
  "ON_WAREHOUSE",
  "SHIPPED_TO_BUYER",
  "DELIVERED_TO_BUYER",
  "CANCELLED",
  "WAITING_FOR_MANUAL_CANCELLATION",
  "TO_BE_REFUNDED",
  "UNKNOWN",
];

export const orderStatusOptions = (baseKey: string) =>
  orderStatuses.map((status) => ({
    value: status,
    label: `${baseKey}.${status}`,
  }));
